'use client';

import React, { forwardRef } from 'react';
import { type SyntheticEvent } from 'react';

import { cn } from '@wwe-portal/ui/lib/lib';

import { a11yButtonProps } from '../../lib/a11y';

type Props = Omit<React.ComponentProps<'div'>, 'onClick'> & {
  onClick?: (e: SyntheticEvent) => void;
};
export const ClickableDiv = forwardRef<HTMLDivElement, Props>(
  ({ onClick, role, className, ...props }, ref) => {
    const a11yProps = a11yButtonProps({
      onClick: (e) => onClick?.(e),
      role,
    });
    return (
      <div
        className={cn('cursor-pointer select-none', className)}
        ref={ref}
        {...props}
        {...a11yProps}
      />
    );
  }
);

ClickableDiv.displayName = 'ClickableDiv';
